import { createFileRoute } from '@tanstack/react-router'
import LoginPage from "../pages/AuthPage/LoginPage";

export const Route = createFileRoute('/')({
  component: LoginPage,
})
